import React from "react";
import { Callout } from "@fluentui/react";
import TimelineLabelForm from "src/components/Planner/TimelineLabelForm/TimelineLabelForm";

interface ITimelineColumnLabelCalloutProps {
    isOpen: boolean;
    targetId: string;
    date: Date;
    onClose: () => void;
}

const TimelineColumnLabelCallout = (props: ITimelineColumnLabelCalloutProps) => {
    if (!props.isOpen) {
        return null;
    }

    return (
        <Callout
            preventDismissOnResize
            role="alertdialog"
            gapSpace={0}
            setInitialFocus
            onDismiss={props.onClose}
            className="users-selection"
            target={props.targetId}
        >
            <TimelineLabelForm
                date={props.date}
                onDone={props.onClose}
            />
        </Callout>
    );
};

export default TimelineColumnLabelCallout;
